<template>
  <InfoBranch
    v-if="!!item.config && !!item.config['shared-secret']"
    :content="item.config['shared-secret']"
    :style="{
      marginTop: '2px',
    }"
  />
</template>
<script>
import InfoBranch from '../utils/InfoBranch'
export default {
  name: 'TriggerWebhook',
  components: {
    InfoBranch
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>